import { IOffer } from '../interfaces/offer';
import axios from './axios';
import { getConfig } from '../utils/sessionStorageUtils';

export const getOffers = async (url: string) => {
  try {
    const result = await axios.get(`/Offers/${url || ''}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getOffer = async (url: string) => {
  try {
    const result = await axios.get(url, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const changeStatus = async (id: string, offerStatus: number) => {
  try {
    const result = await axios.put(`/Offers/offer-status`, { id, offerStatus }, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const deleteOffer = async (offer: IOffer) => {
  try {
    const result = await axios.delete(`/Offers/${offer?.id}`, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const exportOffers = async (url: string) => {
  try {
    const result = await axios.get(`/Export/export-data-to-drive/orders/${url || ''}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
